import {Route, Routes} from 'react-router';
import Layout from '../components/Layout/Layout';

import MainPage from '../pages/MainPage/MainPage';
import ServicesPage from '../pages/ServicesPage/ServicesPage';
import FAQPage from '../pages/FAQPage/FAQPage';
import RecordPage from '../pages/RecordPage/RecordPage';
import SubServicesPage from '../pages/ServicesPage/SubSevricesPage';

function Root() {
    return (
        <Routes>
            <Route path="/" element={<Layout/>}>
                <Route index element={<MainPage/>}/>
                <Route path="/services" element={<ServicesPage/>}/>
                <Route path="/faqs" element={<FAQPage/>}/>
                <Route path="/online_record" element={<RecordPage/>}/>
                <Route path="/services/:group" element={<SubServicesPage/>}/>
            </Route>
        </Routes>
    );
}

export default Root;
